export default "__VITE_ASSET__CPCFDpcq__"